import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useStoreActions, useStoreState } from '../../../../store/hooks'
import ColorToMove from '../../components/ColorToMove'
import ArrowIcon from '../../icons/Arrow'
import PuzzlePracticeControls from '../components/PuzzlePracticeControls'

const MobilePP: React.FC = () => {
    const myColor = useStoreState((state) => state.puzzlePracticeView.myColor)
    const disableNextButton = useStoreState((state) => state.puzzlePracticeView.disableNextButton)
    const puzzleState = useStoreState((state) => state.puzzlePracticeView.puzzleState)

    const handleNext = useStoreActions((state) => state.puzzlePracticeView.handleNext)

    const onNext = () => {
        handleNext()
    }

    return (
        <Stack alignItems="center" spacing="8px">
            {/* Color to move / Next Button */}
            {puzzleState === true ? (
                <Button
                    onClick={onNext}
                    endIcon={<ArrowIcon />}
                    variant="contained"
                    size="medium"
                    disabled={disableNextButton}
                >
                    Next Puzzle
                </Button>
            ) : (
                <ColorToMove playerColor={myColor} />
            )}
            {/* Controls */}
            <PuzzlePracticeControls />
        </Stack>
    )
}

export default MobilePP
